import { HttpInterceptorFn } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { Observable } from 'rxjs';

// AngularFire's modular SDK (Auth/Firestore, initialized app-wide) can leave
// unrelated HTTP responses resolving outside NgZone, so components relying on
// automatic change detection (isLoading flags, etc.) silently stop updating.
// Force every response back into the Angular zone here, once, instead of
// patching every component that subscribes to an HTTP call.
export const ensureZoneInterceptor: HttpInterceptorFn = (request, next) => {
  const ngZone = inject(NgZone);

  return new Observable((subscriber) => {
    const subscription = next(request).subscribe({
      next: (event) => ngZone.run(() => subscriber.next(event)),
      error: (error) => ngZone.run(() => subscriber.error(error)),
      complete: () => ngZone.run(() => subscriber.complete()),
    });
    return () => subscription.unsubscribe();
  });
};
